module.exports = __webpack_public_path__ + "media/一起走出去.de14a907.mp3";